import translate from '@translate';
import React, { FC } from 'react';
import { ReturnType } from 'src/types/return';
import FileUpload, { FilesPropType } from 'src/components/FileUpload';
import EntityFilesTable from 'src/components/FileUpload/EntityFilesTable';
import { sizes } from 'src/themes/default';
import { FileType } from 'src/types/file';
import { FormErrorsType, OnChangeType } from '../../types/global';
import { EditKeysType } from './constants';

export interface DetailPropsType {
    onChange: OnChangeType<EditKeysType>;
    editData: ReturnType;
    editErrors: FormErrorsType;
    isAttributeEditDisabled: (key: string) => boolean;
    skladonUser?: number;
}

const FilesBlock: FC<DetailPropsType> = (props) => {
    const handleChange = (value: FilesPropType, error: boolean) => {
        props.onChange(
            'FILES',
            value.map((file) => ({ ...file, type: 'file' })),
            error
        );
    };

    const handleDeleteFile = (file: FileType) => {
        const list = props.editData.FILES || [];
        props.onChange(
            'FILES',
            list.filter((oldFile) => oldFile !== file).map((f) => ({ ...f, type: 'file' })),
            false
        );
    };

    const filesDisabled = props.isAttributeEditDisabled('FILES');

    return (
        <div style={{ paddingTop: sizes.body_PD }}>
            <FileUpload
                label={translate('returnDetail.files')}
                files={props.editData.FILES}
                onChange={(value, error) => handleChange(value, error)}
                name="image"
                error={props.editErrors.image}
                height={130}
                disabled={filesDisabled}
                multiple
                displayFilesList={false}
            />
            <EntityFilesTable
                files={props.editData.FILES}
                disabled={filesDisabled}
                onDeleteFile={handleDeleteFile}
                skladonUser={props.skladonUser}
                testIdPrefix="return-files"
            />
        </div>
    );
};

export default FilesBlock;
